import * as React from "react";

import SatelliteButton from "./SatelliteButton";
import { IGcpAppDispatchProp } from "../../../redux/store";
import { userClicksSatelliteMapButton } from "./scenarios";
import { connect } from "react-redux";
import { getWorldLayerState, IStoreState } from "../../../redux/rootReducer";
import { IWorldLayerState } from "../../../redux/modules/worldLayer/reducer";

interface ISatelliteButtonContainerProps extends IGcpAppDispatchProp {
  worldLayerState: IWorldLayerState;
}

const SatelliteButtonContainer = ({
  dispatch,
  worldLayerState,
}: ISatelliteButtonContainerProps) => (
  <SatelliteButton
    onClick={() => dispatch(userClicksSatelliteMapButton())}
    satelliteLayerIsOn={worldLayerState.satelliteLayerIsOn}
  />
);

export default connect((state: IStoreState) => ({
  worldLayerState: getWorldLayerState(state),
}))(SatelliteButtonContainer);
